import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILED,
  INVITE_USER,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAILED,
  DISABLE_USER,
  DISABLE_USER_SUCCESS,
  DISABLE_USER_FAILED,
  CHANGE_USER_ROLE,
  CHANGE_USER_ROLE_SUCCESS,
  CHANGE_USER_ROLE_FAILED,
  RESET_INVITE_USER,
} from './constants';

const INIT_STATE = {
  users: [],
  loading: false,
  error: null,

  inviteUser: {
    loading: false,
    error: null,
    success: false,
  },
  disableUser: {
    loading: false,
    error: null,
    success: false,
  },
  changeUserRole: {
    loading: false,
    error: null,
    success: false,
  },
};

const UserManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_USERS:
      return { ...state, loading: true, error: null };
    case FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case FETCH_USERS_FAILED:
      return { ...state, loading: false, error: action.payload };

    case INVITE_USER:
      return { ...state, inviteUser: { loading: true, error: null, success: false } };
    case INVITE_USER_SUCCESS:
      return { ...state, inviteUser: { loading: false, error: null, success: true } };
    case INVITE_USER_FAILED:
      return { ...state, inviteUser: { loading: false, error: action.payload, success: false } };

    case RESET_INVITE_USER:
      return { ...state, inviteUser: { loading: false, error: null, success: false } };
        
    case DISABLE_USER:
      return { ...state, disableUser: { loading: true, error: null, success: false } };
    case DISABLE_USER_SUCCESS:
      return { ...state, disableUser: { loading: false, error: null, success: true } };
    case DISABLE_USER_FAILED:
      return { ...state, disableUser: { loading: false, error: action.payload, success: false } };

    case CHANGE_USER_ROLE:
      return { ...state, changeUserRole: { loading: true, error: null, success: false } };
    case CHANGE_USER_ROLE_SUCCESS:
      return { ...state, changeUserRole: { loading: false, error: null, success: true } };
    case CHANGE_USER_ROLE_FAILED:
      return { ...state, changeUserRole: { loading: false, error: action.payload, success: false } };

    default:
      return state;
  }
};

export default UserManagement;
